/**
 * Plantafel Debug Utility
 *
 * Aktivieren in Browser Console: window.__PLANTAFEL_DEBUG__ = true
 * Deaktivieren: window.__PLANTAFEL_DEBUG__ = false
 */

declare global {
  interface Window {
    __PLANTAFEL_DEBUG__?: boolean;
  }
}

export function plantafelDebugEnabled(): boolean {
  return process.env.NODE_ENV === 'development' && !!window.__PLANTAFEL_DEBUG__;
}

export function pdebug(...args: unknown[]): void {
  if (!plantafelDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log('[Plantafel]', ...args);
}

export function pdebugWarn(...args: unknown[]): void {
  if (!plantafelDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.warn('[Plantafel]', ...args);
}

export function pdebugError(...args: unknown[]): void {
  // Errors always show (important for debugging)
  // eslint-disable-next-line no-console
  console.error('[Plantafel]', ...args);
}
